import React from 'react'
import './index.scss';

interface IProps { 
  title:string,
}
const CustomTitle: React.FC<IProps> = ({ title})=>{
  return (
    <div className='title'>{ title}</div>
  )
}

export default CustomTitle;